import React from 'react'
import Layout from '../components/Layout'
import ImageUploader from '../components/profile/ImageUploader';
import { useDispatch, useSelector } from 'react-redux';
import { fetchUpdateProfile, updateField } from '../redux/slices/UserSlice';
import { useAccount } from 'wagmi';

export default function Profile() {
    const walletAddress = useSelector((state) => state.user.address);
    const username = useSelector((state) => state.user.username);
    const bio = useSelector((state) => state.user.bio);
    const blockstar = useSelector((state) => state.user.blockstar);
    const twitter = useSelector((state) => state.user.twitter);
    const loading = useSelector((state) => state.user.loading);
    const dispatch = useDispatch()
    const { address } = useAccount()

    const handleChange = (e) => {
        const { name, value } = e.target;
        dispatch(updateField({ field: name, value }));
    };

    return (
        <Layout>
            <div class="no-bottom no-top" id="content">
                <section id="section-main" aria-label="section">
                    <div class="container">
                        <div class="row">
                            <div class="col-lg-8 offset-lg-2">
                                <form id="form-create-item" class="form-border" method="post" action="email.php">
                                    <div class="de_tab tab_simple">

                                        <ul class="de_nav">
                                            <li class="active"><span><i class="fa fa-user"></i>Profile</span></li>
                                        </ul>

                                        <div class="de_tab_content">
                                            <div class="tab-1">
                                                <div class="row wow fadeIn">
                                                    <div class="col-lg-8 mb-sm-20">
                                                        <div class="field-set">

                                                            <h5>Wallet Address</h5>
                                                            <input type="text" value={walletAddress} readOnly={true} name="address" id="address" class="form-control" placeholder="Enter email" />
                                                            <div class="spacer-10"></div>

                                                            <h5>Username</h5>
                                                            <input type="text" onChange={(e) => handleChange(e)} value={username} name="username" id="username" class="form-control" placeholder="Enter username" />

                                                            <div class="spacer-10"></div>

                                                            <h5>Bio</h5>
                                                            <textarea name="bio" onChange={(e) => handleChange(e)} id="bio" rows="5" class="form-control" placeholder="Tell the world who you are!">{bio}</textarea>

                                                            <div class="spacer-10"></div>

                                                            <h5><i class="fa fa-star"></i> BlockStar</h5>
                                                            <input type="text" onChange={(e) => handleChange(e)} value={blockstar} name="blockstar" id="blockstar" class="form-control" placeholder="Enter BlockStar username" />

                                                            <div class="spacer-10"></div>

                                                            <h5><i class="fa fa-twitter"></i> Twitter</h5>
                                                            <input type="text" onChange={(e) => handleChange(e)} value={twitter} name="twitter" id="twitter" class="form-control" placeholder="Enter Twitter username" />

                                                        </div>
                                                    </div>

                                                    <div id="sidebar" class="col-lg-4">
                                                        <h5>Profile image <i class="fa fa-info-circle id-color-2" data-bs-toggle="tooltip" data-bs-placement="top" title="Recommend 400 x 400. Max size: 50MB. Click the image to upload."></i></h5>

                                                        <ImageUploader type="profile" />

                                                        <div class="spacer-30"></div>

                                                        <h5>Profile banner <i class="fa fa-info-circle id-color-2" data-bs-toggle="tooltip" data-bs-placement="top" title="Recommend 1500 x 500. Max size: 50MB. Click the image to upload."></i></h5>
                                                        <ImageUploader type="banner" />

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="spacer-30"></div>
                                    <button type="button" disabled={loading} onClick={()=>{
                                        dispatch(fetchUpdateProfile({update : {} , address : address }))
                                    }} class="btn-main">
                                        Submit
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </Layout>
    )
}
